// extracted by mini-css-extract-plugin
export var details = "_j0-0";
export var inspectorPopover = "_j0-1";